import React, { useEffect, useState } from "react";
import MuiDenseTable from "../../../../common-utilities/core/mui-dense-table";
import {
  HOSTNAME,
  INTRANETHOSTNAME,
  REPORT_HOSTNAME,
} from "../../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../../common-utilities/utils/end-points/tech-net";
import { invokeApi } from "../../../utils/http-service";
import { HTTP_METHODS } from "../../../../common-utilities/utils/http-service";
import { headerConfig } from "./config";
import FiltersPanel from "./filter-panel";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { getOfflineData } from "../../../../common-utilities/utils/offline-services";
import { userTypes } from "../../../utils/constants";
import { tokenMainKeys } from "../../../../../utils/constants";
import { STORE_TYPES } from "../../Ticket/config";
import { REGIONS_LIST } from "../../../../store-master/components/store-master/config";
import { convertCamelCaseToDisplayText } from "../../../../common-utilities/utils";
const MainDashboard = () => {
  const [data, setData] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    store: [],
    dept: [],
    category: [],
    am: [],
    storeType: [...STORE_TYPES, { label: "ALL", value: "ALL" }],
    region: [],
    circle: [],
    city: [],
  });
  const FILTER_TYPES = [
    { id: "store", label: "Store" },
    { id: "dept", label: "Department" },
    { id: "category", label: "Category" },
    { id: "am", label: "Area Manager" },
    { id: "storeType", label: "Store Type" },
    { id: "region", label: "Region" },
    { id: "city", label: "City" },
    { id: "circle", label: "Circle" },
  ];
  const [filters, setFilters] = useState({
    page: 1,
    selectedFilters: [],
    isActive: true,
    critical: false,
  });
  const resetHandler = () => {
    setFilters({
      page: 1,
      selectedFilters: [],
      isActive: true,
      critical: false,
    });
    setFilterOptions({
      store: [],
      dept: [],
      category: [],
      am: [],
    });
    defaultFiltersHandler();
  };
  const onPageChange = (page) => {
    setFilters({ ...filters, page });
  };
  const loadManager = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${INTRANETHOSTNAME}${REST_URLS.AM_USERS}`
    ).then((response) => {
      if (response?.length > 0) {
        const results = response.map((r) => {
          return {
            ...r,
            label: r.name,
            value: r.id,
          };
        });
        setFilterOptions((prevVal) => ({ ...prevVal, am: results }));
      }
    });
  };
  const onExpandRow = (particular) => {
    const toggleVisibility = (rows, target) => {
      const newRows = [...rows];
      const parentRow = newRows.find((r) => r.particular === target);

      if (!parentRow) return newRows;

      const isCurrentlyExpanded = newRows.some(
        (r) => r.parent === target && r.showNow
      );

      const toggleChildren = (parent, hide) => {
        newRows.forEach((row) => {
          if (row.parent === parent) {
            row.showNow = !hide;
            if (hide) {
              toggleChildren(row.particular, hide);
            }
          }
        });
      };

      toggleChildren(target, isCurrentlyExpanded);

      return newRows;
    };

    const updatedRows = toggleVisibility([...documentsList], particular);
    setDocumentsList(updatedRows);
  };

  const handleFilterChange = (filterId, value) => {
    if (filterId === "selectedFilters") {
      setFilters((prev) => ({
        ...prev,
        selectedFilters: value,
      }));

      setFilterOptions((prev) => ({
        ...prev,
        selectedFilters: value,
      }));

      value.forEach((filter) => {
        if (
          Array.isArray(filterOptions[filter.id]) &&
          filterOptions[filter.id].length === 0
        ) {
          loadFilterOptionsFor(filter.id);
        }
      });
    } else {
      setFilters((prev) => ({
        ...prev,
        selectedFilters: prev.selectedFilters.map((f) =>
          f.id === filterId ? { ...f, value: value } : f
        ),
      }));
      setFilterOptions((prev) => ({
        ...prev,
        selectedFilters: prev.selectedFilters.map((f) =>
          f.id === filterId ? { ...f, value: value } : f
        ),
      }));
    }
  };
  const loadStores = () => {
    const user = getOfflineData(tokenMainKeys.technet, "user");

    const params = {};
    if (user?.type !== userTypes.STORE_OWNER) {
      params.getAll = true;
    }
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_ALL_STORE_NAMES}`,
      null,
      params
    )
      .then((response) => {
        if (response) {
          const listOfStores = response.map((item) => {
            const {
              name,
              id,
              storeNumber,
              satelliteNumber,
              sequenceNumber,
              restaurantName,
            } = item;

            return {
              label: name
                ? `${name}-${restaurantName}`
                : `${storeNumber}-${sequenceNumber}-${satelliteNumber}-${restaurantName}`,
              value: id,
            };
          });
          setFilterOptions((prevVal) => ({ ...prevVal, store: listOfStores }));
        }
      })
      .catch((err) => console.log(err));
  };
  const loadDepartments = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_ALL_DEPARTMENT_NAMES}`
    )
      .then((res) => {
        if (!res.message) {
          const results = res?.map((ele) => ({
            label: ele?.name,
            value: ele?.id,
          }));
          setFilterOptions((prevVal) => ({ ...prevVal, dept: results }));
        }
      })
      .catch((err) => console.error(err));
  };
  const loadCategories = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_ALL_CATEGORY_NAMES}`
    )
      .then((res) => {
        if (!res.message) {
          const results = res?.map((ele) => ({
            label: ele?.name,
            value: ele?.id,
          }));
          setFilterOptions((prevVal) => ({ ...prevVal, category: results }));
        }
      })
      .catch((err) => console.error(err));
  };
  const loadFilterOptionsFor = (filterId) => {
    switch (filterId) {
      case "store":
        loadStores();
        break;
      case "dept":
        loadDepartments();
        break;
      case "category":
        loadCategories();
        break;
      case "am":
        loadManager();
        break;
      default:
        return;
    }
  };

  const transformApiDataToTableRows = (apiData) => {
    const rows = [];

    const buildTATArray = (data) => [
      { id: "openedCount", value: data?.openedCount ?? "-" },
      { id: "resolvedCount", value: data?.resolvedCount ?? "-" },
      { id: "avgTTR", value: data?.avgTTR ?? "-" },
    ];
    const buildCatTATArray = (data) => [
      { id: "openedCount", value: data?.totalOpenedCount ?? "-" },
      { id: "resolvedCount", value: data?.totalResolvedCount ?? "-" },
      { id: "avgTTR", value: data?.totalAvgTTR ?? "-" },
    ];
    const periods = ["weekly", "monthly", "yearly"];

    const rowMap = new Map();

    const ensureRow = (label, parentLabel = null, level = 0) => {
      const key = `${parentLabel || "ROOT"}-${label}`;
      if (!rowMap.has(key)) {
        rowMap.set(key, {
          particular: label,
          parent: parentLabel,
          showNow: parentLabel ? false : true,
          bold: level === 0,
          child: false,
          level,
          weekly: [],
          monthly: [],
          yearly: [],
        });
      }
      return rowMap.get(key);
    };

    periods.forEach((period) => {
      const deptRes = apiData?.[period]?.deptRes || [];

      deptRes.forEach((deptItem) => {
        const deptRow = ensureRow(deptItem.department, null, 0);
        deptRow[period] = buildTATArray(deptItem);

        (deptItem.categories || []).forEach((catItem) => {
          const catRow = ensureRow(catItem.category, deptItem.department, 1);
          catRow[period] = buildCatTATArray(catItem);

          (catItem.subCat || []).forEach((subItem) => {
            const subRow = ensureRow(subItem.category, catItem.category, 2);
            subRow[period] = buildTATArray(subItem);
          });
        });
      });
    });

    // Mark parents with children
    const allRows = Array.from(rowMap.values());
    allRows.forEach((row) => {
      row.child = allRows.some((r) => r.parent === row.particular);
    });
    allRows
      .filter((r) => r.level === 0)
      .forEach((deptRow) => {
        rows.push(deptRow);
        allRows
          .filter((r) => r.level === 1 && r.parent === deptRow.particular)
          .forEach((catRow) => {
            rows.push(catRow);
            allRows
              .filter((r) => r.level === 2 && r.parent === catRow.particular)
              .forEach((subRow) => {
                rows.push(subRow);
              });
          });
      });

    const grandTotalRow = {
      particular: "Total",
      parent: null,
      showNow: true,
      bold: true,
      child: false,
      level: 0,
      weekly: buildTATArray(apiData?.weekly?.grandTotal ?? {}),
      monthly: buildTATArray(apiData?.monthly?.grandTotal ?? {}),
      yearly: buildTATArray(apiData?.yearly?.grandTotal ?? {}),
    };

    rows.push(grandTotalRow);
    return rows;
  };

  const loadData = (filter) => {
    if (!filters?.week) {
      toast.error("Week is required", {
        autoClose: 2000,
      });
      return;
    }
    const defaultFilters = {
      ...filter,
      isActive: filters?.isActive,
      startDate: filters?.week?.startDate,
      endDate: filters?.week?.endDate,
      critical: filters?.critical,
    };
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.DASHBOARD_REPORT}`,
      null,
      defaultFilters
    )
      .then((res) => {
        if (res?.message) {
          toast.error(res.message);
          setDocumentsList([]);
          setData([]);
        } else {
          const formattedRows = transformApiDataToTableRows(res);
          setDocumentsList(formattedRows);
          setData(formattedRows);
        }
      })
      .catch((err) => console.error(err));
  };
  const searchHandler = () => {
    const params = {};
    if (filters?.selectedFilters?.length > 0) {
      filters.selectedFilters?.forEach((ele) => {
        if (ele?.value) {
          params[ele.id] = ele?.value?.value;
        }
      });
    }

    loadData(params);
  };
  const defaultFiltersHandler = () => {
    const today = dayjs();
    const startOfWeek = today.startOf("isoWeek").toDate();
    const endOfWeek = today.endOf("isoWeek").toDate();

    setFilters((prev) => ({
      ...prev,
      week: { startDate: startOfWeek, endDate: endOfWeek },
    }));
  };
  const loadFilterOptions = () => {
    const params = {};
    filters.selectedFilters.forEach((filter) => {
      if (
        (filter?.id === "region" ||
          filter?.id === "city" ||
          filter?.id === "circle") &&
        filter?.value?.value
      ) {
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          params[filter.id] = filter?.value?.map((v) => v.value || v);
        } else if (filter.value) {
          params[filter.id] = filter.value.value || filter.value;
        }
      }
    });
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LOAD_DASHBOARD_FILTERS_OPTIONS}`,
      null,
      params
    )
      .then((res) => {
        if (!res.message) {
          const city = res?.city?.map((ele) => ({ label: ele, value: ele }));
          const circle = res?.circle?.map((ele) => ({
            label: ele,
            value: ele,
          }));
          const region = res?.region?.map((ele) => ({
            label: convertCamelCaseToDisplayText(ele),
            value: ele,
          }));
          setFilterOptions((prevVal) => ({
            ...prevVal,
            city,
            circle,
            region,
          }));
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    defaultFiltersHandler();
    loadFilterOptions();
  }, []);
  useEffect(() => {
    const isCallApi = filters?.selectedFilters?.find(
      (ele) =>
        ele?.id === "region" || ele?.id === "circle" || ele?.id === "city"
    );
    if (isCallApi) {
      loadFilterOptions();
    }
  }, [filters?.selectedFilters]);
  useEffect(() => {
    if (filters?.week) {
      loadData();
    }
  }, [filters?.week]);
  return (
    <div>
      <FiltersPanel
        filterOptions={filterOptions}
        handleFilterChange={handleFilterChange}
        filters={filters}
        setFilters={setFilters}
        FILTER_TYPES={FILTER_TYPES}
        searchHandler={searchHandler}
        resetHandler={resetHandler}
      />
      <div className="invoice-table">
        <MuiDenseTable
          nestedValue={true}
          columnsList={headerConfig(filters?.week)}
          dataList={data}
          filters={filters}
          pageCount={1}
          onChange={onPageChange}
          onExpandRow={onExpandRow}
          tableContainerClass="summary-table-con"
        />
      </div>
    </div>
  );
};

export default MainDashboard;
